import { Component, input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DOMHandlerService } from '../../../services/domhandler.service';
import { LanguageService } from '../../../services/language.service';
import { ButtonComponent } from '../../common/button/button.component';
import { LinkItem } from '../../../types/navbar.types';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    host: { style: 'margin-top: 0;' },
    styleUrl: './header.component.css',
    standalone: true,
    imports: [ButtonComponent, RouterLink],
})
export class HeaderComponent {
    data = input.required<Header>();
    domhandler = inject(DOMHandlerService);
    languageService = inject(LanguageService);

    constructor() {
        this.domhandler.addStructuredData(
            this.domhandler.getApartmentStructuredData(),
        );
    }
}

type Header = {
    slogan: string;
    heroImage: Image;
    callToAction: LinkItem;
};

export type Image = {
    documentId: string;
    alternativeText: string;
    width: number;
    height: number;
    formats: Formats;
    url: string;
};

export type Formats = {
    thumbnail: FormatInfo;
    small: FormatInfo;
    medium: FormatInfo;
    large: FormatInfo;
};

type FormatInfo = {
    name: string;
    ext: string;
    path: null;
    width: number;
    height: number;
    size: number;
    url: string;
};
